import { useMemo, useState } from "react";
import { useAuth } from "../../js/hooks/useAuth";
import { useJourneyLive } from "../../js/hooks/useJourneyLive";
import { listAdminBrokerMessages, listBrokers, sendAdminBrokerMessage } from "../../js/api/adminDesk";
import { formatDate } from "../../js/utils/formatters";

export default function AdminBrokerNotes() {
  const { session } = useAuth();
  const [pulse, setPulse] = useState(0);
  const brokers = useMemo(() => listBrokers(), [pulse]);
  const messages = useMemo(() => listAdminBrokerMessages(), [pulse]);
  const [msgText, setMsgText] = useState("");
  const [recipient, setRecipient] = useState({ id: "", name: "", email: "" });
  const [note, setNote] = useState("");

  useJourneyLive(() => setPulse((n) => n + 1));

  function handleMessage(event) {
    event.preventDefault();
    if (!recipient.id || !msgText.trim()) {
      setNote("Choose a broker from the contact list, then write the note.");
      return;
    }
    sendAdminBrokerMessage({
      to_user_id: recipient.id,
      to_name: recipient.name,
      to_email: recipient.email,
      text: msgText,
      from_name: session?.name || "Site admin",
    });
    setMsgText("");
    setNote("Message stored for this prototype.");
    setPulse((n) => n + 1);
  }

  return (
    <section className="desk-panel card" id="broker-notes">
      <h2>Broker Notes</h2>
      <p className="muted">
        Development correspondence with brokers. Client files stay in the inbox above.
      </p>
      <div className="broker-contact-list">
        <h3>Master Broker Contact List</h3>
        {brokers.length ? (
          <ul className="stack" style={{ listStyle: "none", padding: 0 }}>
            {brokers.map((broker) => (
              <li key={broker.id}>
                <button type="button" className="text-btn" onClick={() => setRecipient(broker)}>
                  {broker.name}
                </button>
                <div className="muted">
                  {broker.email}
                  {broker.office_name ? ` · ${broker.office_name}` : ""}
                  {broker.phone ? ` · ${broker.phone}` : ""}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No brokers on file.</p>
        )}
      </div>
      <form onSubmit={handleMessage} noValidate style={{ marginTop: "0.85rem" }}>
        <p>
          Recipient: <strong>{recipient.name || "None selected"}</strong>
          {recipient.email ? ` · ${recipient.email}` : ""}
        </p>
        <label className="field">
          <span className="field-label">Message</span>
          <textarea
            className="field-textarea"
            rows={5}
            value={msgText}
            onChange={(event) => setMsgText(event.target.value)}
          />
        </label>
        {note ? <p className="confirm-banner">{note}</p> : null}
        <button type="submit" className="primary-btn">
          Send to broker
        </button>
      </form>
      <ul className="stack" style={{ listStyle: "none", padding: 0, marginTop: "1rem" }}>
        {messages.map((item) => (
          <li key={item.id}>
            <strong>{item.to_name}</strong>
            <div className="muted">{formatDate(item.created_at)}</div>
            <p style={{ margin: "0.25rem 0 0" }}>{item.text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
